import React from 'react';
import { useAlert } from 'react-alert'

export default function Heatmap(props) {

    const alert = useAlert()

    if (props && props.afterSubmit) {
        // show success message
        alert.success('Your smell report has been submitted.')
    }

    return (<div>
        <div className="embed-map-container"><iframe frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0" title="OOO Survey Heatmap" src="//ecan.maps.arcgis.com/apps/Embed/index.html?webmap=ffe6d05924fb4b6cb516f6f7547c06b6&center=172.6997013,-43.5346611&level=13&amp;zoom=true&amp;previewImage=false&amp;scale=true&amp;disable_scroll=true&amp;theme=light"></iframe></div>
    </div >)
}